import clsx from 'clsx'
import type { PropsWithChildren, ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'
import { Platform, View } from 'react-native'

import { ResponsiveDisplay } from '@/src/general/components/ResponsiveDisplay'
import { TEST_ID } from '@/src/general/constants/testId'
import { ICON } from '@/src/general/enums/icons'

import { Button } from '../button/default'
import { Card } from '../card'
import { Icon } from '../media/Icon'
import { Message } from '../message'
import { Typography } from '../text/Typography'
import type { TAlertBannerProps } from './AlertBanner.types'

const fingerIcon = '👉🏻'
export const AlertBanner = ({ onClose, children, className }: PropsWithChildren<TAlertBannerProps>): ReactNode => {
  return (
    <Card
      additionalProps={Platform.select({ native: { pointerEvents: 'box-none' }, web: {} })}
      className={clsx(
        'gap-4 overflow-visible p-5 text-secondary-text-contrast-default flex w-full flex-col',
        className,
      )}
      shadow="md"
    >
      {onClose != null && (
        <View className="absolute right-1 top-1 z-10 border-none">
          <Button
            testID={TEST_ID.MISCELLANEOUS.SPECIAL_ALERT_CLOSE_BUTTON}
            colors="secondary"
            isIconOnly
            contrast="low"
            variant="light"
            startIcon={ICON.CLOSE}
            size="xs"
            onPress={onClose}
          />
        </View>
      )}
      <View className="flex w-full flex-row items-center justify-center gap-3 text-center">
        <Typography className={clsx('text-secondary-text-contrast-default', onClose ? 'pr-7' : undefined)}>
          {children}
          <ResponsiveDisplay behavior="minWidth" size="sm">
            <Typography colors="secondary" size="md" className="px-2 underline" ariaRole="span">
              {fingerIcon} <FormattedMessage id="words.click-here" />
            </Typography>
          </ResponsiveDisplay>
        </Typography>
      </View>
      <ResponsiveDisplay behavior="maxWidth" size="xs">
        <Message
          colors="secondary"
          textClassName="flex-row items-center justify-center h-full native:h-8"
          className="native:pt-2 native:pl-4 w-fit self-end bg-secondary-bg-medium px-2 py-1"
        >
          <View className="native:gap-2 flex-row gap-2">
            <Typography colors="secondary" size="md" bold>
              <FormattedMessage id="words.click-here" />
            </Typography>
            <Icon size="sm" name={ICON.CHEVRON_RIGHT} className="h-4 w-4 color-secondary-bg-medium-dark" />
          </View>
        </Message>
      </ResponsiveDisplay>
    </Card>
  )
}
